// @ts-nocheck

import * as TabBarIcons from '../assets/svg/tab-bar';
import { TabBarNavigationTypes } from '../types/tabBar';

const svgResolver = {
  [TabBarNavigationTypes.BASKET]: TabBarIcons.Basket,
  [TabBarNavigationTypes.GRIDS]: TabBarIcons.Grids,
  [TabBarNavigationTypes.MY_BETS]: TabBarIcons.MyBets,
};

export default svgResolver;
